import React, { useState } from "react";
import "./contact.css";
import { FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { HiLocationMarker } from "react-icons/hi";
import SEO from "../../components/SEO";
import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";
import { api } from "../../api/client";
import { getWhatsAppChatUrl, WHATSAPP_DISPLAY } from "../../constants/contact";
import { CONTACT_INTRO } from "../../constants/brand";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
    if (success) setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setSuccess("");
    try {
      const res = await api.post("/contact", form, null);
      setSuccess(res?.message || "Thanks for contacting us. We will get back to you shortly.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError(err?.message || "Could not send your message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <SEO
        title="Contact Us"
        description="Get in touch with Luxistt. Ask about Luxistt apartments, bookings, or partnerships. Reach us via email, WhatsApp, or visit our Enugu office."
        path="/contact-us"
      />
      <Navbar />
      <main className="contact-main">
        <div className="contact-wrapper">
          <header className="contact-header">
            <h1 className="contact-title">Get in touch</h1>
            <p className="contact-intro">{CONTACT_INTRO}</p>
          </header>

          <div className="contact-body">
            <section className="contact-form-section">
              <h2 className="contact-form-title">Send a message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                {error && <div className="contact-alert contact-alert-error">{error}</div>}
                {success && <div className="contact-alert contact-alert-success">{success}</div>}
                <label className="contact-label" htmlFor="contact-name">Name</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  placeholder="Your name"
                  className="contact-input"
                  autoComplete="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <label className="contact-label" htmlFor="contact-email">Email</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  className="contact-input"
                  autoComplete="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <label className="contact-label" htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="Your message…"
                  rows={5}
                  className="contact-textarea"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
                <button type="submit" className="contact-submit" disabled={submitting}>
                  {submitting ? "Sending..." : "Send message"}
                </button>
              </form>
            </section>

            <aside className="contact-info-card">
              <h2 className="contact-info-title">Contact information</h2>
              <ul className="contact-info-list">
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden="true">
                    <MdEmail size={22} />
                  </span>
                  <div>
                    <span className="contact-info-label">Email</span>
                    <a href="mailto:info@luxistt.com" className="contact-info-value">info@luxistt.com</a>
                  </div>
                </li>
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden="true">
                    <FaWhatsapp size={22} />
                  </span>
                  <div>
                    <span className="contact-info-label">WhatsApp</span>
                    <span className="contact-info-value contact-info-whatsapp-line">
                      Whatsapp call on:{' '}
                      <a
                        href={getWhatsAppChatUrl()}
                        className="contact-info-value contact-whatsapp-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {WHATSAPP_DISPLAY}
                      </a>
                    </span>
                  </div>
                </li>
                <li className="contact-info-item">
                  <span className="contact-info-icon" aria-hidden="true">
                    <HiLocationMarker size={22} />
                  </span>
                  <div>
                    <span className="contact-info-label">Corporate Office</span>
                    <span className="contact-info-value contact-info-address">No 3B Onoh Crescent, GRA Enugu</span>
                  </div>
                </li>
              </ul>
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
